import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { EyeOff, Network, RefreshCw } from "lucide-react";

const cards = [
  { icon: EyeOff, title: "THEY HIDE", text: "Bed bugs conceal themselves in mattress seams, bed frames, headboards, baseboards and the smallest cracks — often far from the bed itself. A treatment has to reach where they actually harbour, not only the obvious spots." },
  { icon: Network, title: "THEY SPREAD", text: "Bed bugs move between belongings, second-hand furniture and connected living environments such as apartment and condo units. Containment and coordination across units matter as much as the treatment itself." },
  { icon: RefreshCw, title: "THEY PERSIST", text: "Surviving bed bugs rebound quickly. Appropriate treatment, correct customer preparation and a planned follow-up — where required — are what prevent the infestation from returning." }
];

export default function WhyBedBugs() {
  return (
    <section id="why" className="border-b border-border bg-primary px-5 py-24 text-white lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <SectionHeader
          dark
          kicker="Why Bed Bugs?"
          title="BECAUSE BED BUGS PLAY BY DIFFERENT RULES."
        />
        <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/60">
          Bed bugs hide, spread and persist in ways that general pest control isn't built for. Each of those behaviours shapes how a treatment should be planned and carried out — which is why a dedicated bed bug service gets results a general approach often doesn't.
        </p>
        <div className="mt-16 grid gap-4 md:grid-cols-3">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="group h-full rounded-lg border border-white/10 bg-white/[0.03] p-8 transition-colors hover:border-accent/40">
                <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-md border border-white/10 bg-white/5 text-accent">
                  <c.icon className="h-5 w-5" />
                </div>
                <h3 className="font-heading text-xl font-bold tracking-wide">{c.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-white/65">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-14 border-l-2 border-accent pl-6 font-heading text-2xl font-bold tracking-tight sm:text-3xl">
            THAT'S WHY OUR SERVICE IS BUILT AROUND BED BUGS.
          </p>
        </Reveal>
      </div>
    </section>
  );
}